import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../api';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('access_token'));

  useEffect(() => {
    const initAuth = async () => {
      const storedToken = localStorage.getItem('access_token');
      if (storedToken) {
        try {
          const response = await authAPI.getMe();
          setUser(response.data);
          setToken(storedToken);
        } catch (error) {
          localStorage.removeItem('access_token');
          setToken(null);
        }
      }
      setLoading(false);
    };

    initAuth();
  }, []);

  const login = async (username, password) => {
    try {
      const response = await authAPI.login(username, password);
      const { access_token } = response.data;
      
      localStorage.setItem('access_token', access_token);
      setToken(access_token);
      
      const userResponse = await authAPI.getMe();
      setUser(userResponse.data);
      
      return { success: true };
    } catch (error) {
      return { 
        success: false, 
        error: error.response?.data?.detail || 'Login failed' 
      };
    }
  };

  // TEMPORARILY DISABLED - Register functionality
  // const register = async (userData) => {
  //   try {
  //     const response = await authAPI.register(userData);
  //     return { success: true, data: response.data };
  //   } catch (error) {
  //     return { 
  //       success: false, 
  //       error: error.response?.data?.detail || 'Registration failed' 
  //     };
  //   }
  // };

  const logout = () => {
    localStorage.removeItem('access_token');
    setToken(null);
    setUser(null);
  };

  // Helper function to check if user is salesman (user ID 4)
  const isSalesman = (user) => {
    return user && user.id === 4;
  };

  const value = {
    user,
    token,
    loading,
    login,
    // register, // TEMPORARILY DISABLED
    logout,
    isAuthenticated: !!token && !!user,
    isSalesman: isSalesman(user),
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
